const EMAIL_REGEX = /\S+@\S+\.\S+/;
const PHONE_REGEX = /^[6789]\d{9}$/;

export const IsEmailValid = (email) => {
    return EMAIL_REGEX.test(email)
}

export const IsPhoneNoValid = (phoneno) => {
    return PHONE_REGEX.test(phoneno)
}